<template>
  <div class="policy-container">
    <PcPage v-if="isPc" :policy-info="policyInfo"></PcPage>
    <MobilePage v-else :policy-info="policyInfo"></MobilePage>
  </div>
</template>

<script>
import _ from 'lodash'
import { deviceType } from '@/utils/common'
import MobilePage from './mobile.vue'
import PcPage from './pc.vue'
import { mapActions } from 'vuex'
import { addI18nProperty } from '@/i18n'

export default {
  metaInfo () {
    return {
      title: this.pageTitle
    }
  },
  components: {
    MobilePage,
    PcPage
  },
  data () {
    return {
      isPc: deviceType.isPc,
      policyInfo: {}
    }
  },
  computed: {
    policyId () {
      return this.$route.query.policyId
    },
    policyType () {
      return _.toUpper(this.$route.params.policyType)
    },
    pageTitle () {
      return this.$t(`admin.company.agreement.label.${this.policyType}`)
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    ...mapActions('agreement', ['getSystemPolicyById', 'getSystemPolicyByType']),
    async loadData () {
      const params = {}
      let func = null
      if (this.policyId) {
        params.policy_id = this.policyId
        func = this.getSystemPolicyById
      } else {
        params.policy_type = this.policyType
        func = this.getSystemPolicyByType
      }
      const resp = await func(params)
      if (resp) {
        this.policyInfo = addI18nProperty(resp, 'i18nContent', 'content_cn', 'content_en')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.policy-container {
  font-size: 12px;
  line-height: normal;
  height: 100vh;
  overflow: auto;

  ::v-deep * {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
}
</style>
